var qvthumbnails, cookieName = "wishlistList";

function convertToMobile() {
    $(document).find(".responsive-sidebar").append('<div class="shopify-section" id="shopify-section-Ishi_sidebar">' + $(document).find(".normal-sidebar .shopify-section").html() + "</div>"), $(document).find(".normal-sidebar").find(".shopify-section").remove(), $("*[id^='_desktop_']").each(function(e, t) {
        var i = $("#" + t.id.replace("_desktop_", "_mobile_"));
        swapElements($(this), i)
    })
}

function converToDesktop() {
    $(document).find(".normal-sidebar").append('<div class="shopify-section" id="shopify-section-Ishi_sidebar">' + $(document).find(".responsive-sidebar .shopify-section").html() + "</div>"), $(document).find(".responsive-sidebar").find(".shopify-section").remove()
}

function swapElements(e, t) {
    t.html(e.html()), e.html("")
}

function productRemoveFormCart(e) {
    jQuery.ajax({
        type: "post",
        url: "/cart/change.js",
        data: "quantity=0&id=" + e,
        dataType: "json",
        beforeSend: function() {},
        success: function(e) {
            adjustCartDropDown()
        },
        error: function(e, t) {}
    })
}

function adjustCartDropDown() {
    Shopify.getCart(function(e) {
//         console.log(e), console.log(Shopify.shop);
        var t = $("#cart-container .product-list");
        t.html("");
        var i = $("#cart-container .cart__empty"),
            a = $("#cart-container .cart__footer");
        $(".cart__subtotal").html(Shopify.formatMoney(e.total_price, Shopify.money_format)), $(".cart-qty").html(e.item_count), e.items.length > 0 ? ($.each(e.items, function(e, i) {
            var a = $("<div class='product'></div>"),
                o = $("<div class='product-img'></div>"),
                s = $("<div class='product-data'></div>");
            o.append("<img src='" + i.image + "' alt='" + i.title + "''>"), s.append("<a href='" + i.url + "' class='product-title'>" + i.title + "</a>"), s.append("<span class='product-price'>" + i.quantity + " x " + Shopify.formatMoney(i.discounted_price, Shopify.money_format) + "</span>"), a.append(o), a.append(s), a.append("<a class='remove' data-variantid=" + i.variant_id + "><i class='material-icons'>delete</i></a>"), t.append(a)
        }), a.removeClass("hide"), t.removeClass("hide"), i.addClass("hide"), t.slimScroll({
            height: e.items.length > 1 ? "262px" : "100%"
        })) : (i.removeClass("hide"), a.addClass("hide"), t.addClass("hide"))
    })
}

function adjustProductInventory() {
    var e = $("#AddToCart-product-template").attr("disabled");
    void 0 !== e && !1 !== e ? ($("#inventory span.instock").hide(), $("#inventory span.outstock").show()) : ($("#inventory span.instock").show(), $("#inventory span.outstock").hide())
}

function LeftowlCarouselReinitialize() {
    $("#ishitestimonials-carousel").owlCarousel({
        nav: !0,
        navText: ["<i class='material-icons'></i>", "<i class='material-icons'></i>"],
        dots: !1,
        autoplay: !1,
        autoplayHoverPause: !1,
        loop: !1,
        rewind: !0,
        items: 1
    }), $(".newproductblock.owl-carousel").owlCarousel({
        loop: !1,
        nav: !0,
        dots: !1,
        rewind: !0,
        margin: 15,
        navText: ["<i class='material-icons'></i>", "<i class='material-icons'></i>"],
        responsive: {
            0: {
                items: 2
            },
            543: {
                items: 2
            },
            767: {
                items: 3
            },
            992: {
                items: 1
            },
            1200: {
                items: 2
            }
        }
    })
}

function hb_animated_contents() {
    jQuery(".hb-animate-element:in-viewport").each(function(e) {
        var t = jQuery(this);
        t.hasClass("hb-in-viewport") || setTimeout(function() {
            t.addClass("hb-in-viewport")
        }, 200 * e)
    })
}
$(document).ready(function() {
    $("#siteloader").fadeOut(), $("#spin-wrapper").fadeOut(),
        function(e) {
            function t() {
                if (window.matchMedia("(min-width: 992px)").matches) {
                    var t = e("#header").height();
                    e("#header .site-header-inner").height();
                    e(window).scroll(function() {
                        e(window).scrollTop() > t ? e("#header .site-header-inner").addClass("fixed-header") : e("#header .site-header-inner").removeClass("fixed-header")
                    })
                } else {
                    t = e("#header").height(), e("#header .site-header-inner").height();
                    e(window).scroll(function() {
                        e(window).scrollTop() > t && e("#header .site-header-inner").hasClass("fixed-header") && e("#header .site-header-inner").removeClass("fixed-header")
                    })
                }
            }
            t(), window.addEventListener("resize", t, !1)
        }(jQuery);
    var e = $("#header").height();
    $("#header .mobile-width").height();

    function t(e, t) {
        var i = e.left + t,
            a = $(window).width() - i;
        return a < 0 ? a - 15 : 0
    }

    function i() {
        if (0 == $(".add-in-wishlist-js").length) return !1;
        $(".add-in-wishlist-js").each(function() {
            $(this).unbind(), $(this).click(function(e) {
                e.preventDefault();
                try {
                    var t = $(this).data("href");
                    if (null == $.cookie(cookieName)) var i = t;
                    else if (-1 == $.cookie(cookieName).indexOf(t)) i = $.cookie(cookieName) + "__" + t;
                    $.cookie(cookieName, i, {
                        expires: 14,
                        path: "/"
                    }), jQuery(".loadding-wishbutton-" + t).show(), jQuery(".default-wishbutton-" + t).remove(), setTimeout(function() {
                        jQuery(".loadding-wishbutton-" + t).remove(), jQuery(".added-wishbutton-" + t).show();
                        var e = $("#wishlistmessage .title-success").text();
                        $.notify({
                            message: e
                        }, {
                            type: "success",
                            offset: 0,
                            placement: {
                                from: "top",
                                align: "center"
                            },
                            z_index: 9999,
                            animate: {
                                enter: "animated fadeInDown",
                                exit: "animated fadeOutUp"
                            },
                            template: '<div data-notify="container" class="col-xs-12 alert alert-{0}" role="alert"><button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button><span data-notify="icon"></span> <span data-notify="title">{1}</span> <span data-notify="message">{2}</span><div class="progress" data-notify="progressbar"><div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div><a href="{3}" target="{4}" data-notify="url"></a></div>'
                        })
                    }, 2e3), $(this).unbind()
                } catch (e) {}
            })
        })
    }
    $(window).scroll(function() {
            $(window).scrollTop() > e ? $(".mobile-width").addClass("fixed-header") : $(".mobile-width").removeClass("fixed-header")
        }), /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? $(".parallax").sitManParallex({
            invert: !0
        }) : $(".parallax").length && $(".parallax").sitManParallex({
            invert: !1
        }), $("#SortTags").on("click", "a", function(e) {
            if ($(this).hasClass("selected")) {
                var t = $(this).data("tagname"),
                    i = (o = window.location.href).indexOf(t),
                    a = i + t.length;
                if (e.preventDefault(), "/" == o.charAt(i - 1)) o = (o = o.replace(t, "")).replace("+", ""), window.location = o;
                else if ("" == o.charAt(a + 1)) {
                    o = (o = o.replace(t, "")).substring(0, o.length - 1), window.location = o
                } else {
                    var o = o.substring(0, i) + o.substring(a + 1);
                    window.location = o
                }
            }
        }), $("#product-thumbnails-carousel").owlCarousel({
            nav: !0,
            navText: ["<i class='material-icons'></i>", "<i class='material-icons'></i>"],
            dots: !1,
            loop: !1,
            margin: 15,
            rewind: !0,
            responsive: {
                0: {
                    items: 3
                },
                543: {
                    items: 4
                },
                767: {
                    items: 3
                },
                991: {
                    items: 3
                },
                1200: {
                    items: 4
                }
            }
        }), qvthumbnails = $("#qv-thumbnails").owlCarousel({
            nav: !0,
            loop: !1,
            navText: ["<i class='material-icons'></i>", "<i class='material-icons'></i>"],
            responsive: {
                0: {
                    items: 3
                },
                543: {
                    items: 5
                },
                767: {
                    items: 4
                },
                991: {
                    items: 4
                },
                1200: {
                    items: 5
                }
            }
        }), $("#ishi-servicesblock").owlCarousel({
            loop: !0,
            nav: !1,
            dots: !1,
            rewind: !0,
            autoplay: !0,
            autoplayTimeout: 4e3,
            navText: ["<i class='material-icons'></i>", "<i class='material-icons'></i>"],
            responsive: {
                0: {
                    items: 1
                },
                543: {
                    items: 2
                },
                767: {
                    items: 1
                },
                992: {
                    items: 2
                },
                1200: {
                    items: 2
                }
            }
        }), $(".megamenu-header").html($(".megamenu-section").html()), $(".megamenu-section").html(""), $("input.update-cart").on("input", function(e) {
            setTimeout(function() {
                $(".update-qty").trigger("click")
            }, 800)
        }), $(window).scroll(function() {
            $(this).scrollTop() > 500 ? $("#slidetop").fadeIn(500) : $("#slidetop").fadeOut(500)
        }), $("#slidetop").click(function(e) {
            e.preventDefault(), $("html, body").animate({
                scrollTop: 0
            }, 800)
        }), $(document).on("click", ".product-form__item--quantity .button", function() {
            var e = $(".product-form__item--quantity .quantity").val();
            if ("+" == $(this).text()) var t = parseInt(e) + 1;
            else {
                if (1 == e) return;
                t = parseInt(e) - 1
            }
            $("input.quantity").val(t), $(".update-qty").trigger("click")
        }), $(document).on("click", ".cart-qty-btns .button", function() {
            var e = $(this).siblings(".quantity").val();
            if ("+" == $(this).text()) var t = parseInt(e) + 1;
            else {
                if (1 == e) return;
                t = parseInt(e) - 1
            }
            $(this).siblings(".quantity").val(t), $(".update-qty").trigger("click")
        }), $(document).on("click", ".list-img", function(e) {
            $(this).hasClass("checked") || ($("#list-img").addClass("checked"), $("#grid-img").removeClass("checked"), $(".products-display-collection .grid__item").each(function() {
                $(this).removeClass("small--one-half"), $(this).removeClass("lg-up--one-third"), $(this).removeClass("grid__item"), $(this).removeClass(" medium-up--one-quarter"), $(this).addClass("one-whole"), $(this).addClass("list__item"), $(this).removeClass("col-sm-6 col-md-4 col-lg-4"), i();
                var e = $(this).find(".thumbnail-buttons").html();
                $(this).find(".thumbnail-buttons").remove(), $(this).find(".product-description").append('<div class="thumbnail-buttons">' + e + "</div>"), i()
            }), $(".products-display-collection .grid-view-item__image-wrapper").each(function() {
                $(this).addClass("col-sm-4 col-md-4 col-lg-4")
            }), $(".products-display-collection .product-description").each(function() {
                $(this).addClass("col-sm-8 col-md-8 col-lg-8")
            }), $("#Collection").fadeOut(0), $("#Collection").fadeIn(500))
        }), $(document).on("click", ".grid-img", function(e) {
            $(this).hasClass("checked") || ($("#list-img").removeClass("checked"), $("#grid-img").addClass("checked"), $(".products-display-collection .list__item").each(function() {
                $(this).addClass("small--one-half"), $(this).addClass("grid__item"), $(this).addClass("lg-up--one-third"), $(this).removeClass("one-whole"), $(this).removeClass("list__item"), $(this).addClass("col-sm-6 col-md-4 col-lg-4"), i();
                var e = $(this).find(".thumbnail-buttons").html();
                $(this).find(".thumbnail-buttons").remove(), $(this).find(".grid-view-item__image-wrapper").append('<div class="thumbnail-buttons">' + e + "</div>"), i()
            }), $(".products-display-collection .grid-view-item__image-wrapper").each(function() {
                $(this).removeClass("col-sm-4 col-md-4 col-lg-4")
            }), $(".products-display-collection .product-description").each(function() {
                $(this).removeClass("col-sm-8 col-md-8 col-lg-8")
            }), $("#Collection").fadeOut(0), $("#Collection").fadeIn(500))
        }), $("#left-column-category").length > 0 && ($("#left-column-category").html($("#_desktop_top_menu").html()), $("#left-column-category").find(".dropdown-inner").css("width", "auto")), $(".category-tree").each(function() {
            var e;
            e = document.getElementById("top-menu").innerHTML.replace(/_n_/g, "_m_"), document.getElementById("top-menu").innerHTML = e
        }), $(document).on("click", ".nm-addToCart.enable", function() {
            var e = $(this).parents(".add_to_cart_main").find('input[name="prduct-variant"]').val(),
                t = $(this).parents(".add_to_cart_main").find('input[name="product-quantity"]').val();
            $(this).addClass("adding"), productAddToCart(e, t), $(".cart-display #cart-container").hasClass("in") && ($(".cart-display #cart-container").removeClass("in"), $(".cart-display .cart-title").addClass("collapsed"), $(".cart-display .cart-title").attr("aria-expanded", "false"))
        }), $(window).width() < 992 && convertToMobile(), $("#menu-icon").on("click", function() {
            $("#mobile_top_menu_wrapper").animate({
                width: "toggle"
            })
        }), $("#top_menu_closer i").on("click", function() {
            $("#mobile_top_menu_wrapper").animate({
                width: "toggle"
            })
        }), $("#_desktop_top_menu .category").each(function(e) {
            var i = $(this).find(".sub-menu .sub-category").length,
                a = $(this).find(".sub-menu");
            switch (i) {
                case 1:
                    a.css("width", "230px"), a.css("left", t(a.offset(), 230));
                    break;
                case 2:
                    a.css("width", "430px"), a.css("left", t(a.offset(), 430));
                    break;
                case 3:
                    a.css("width", "630px"), a.css("left", t(a.offset(), 630));
                    break;
                case 4:
                    a.css("width", "830px"), a.css("left", t(a.offset(), 830))
            }
        }), $(document).on("click", "#cart-container a.remove", function() {
            productRemoveFormCart($(this).data("variantid"))
        }), $(document).on("change", "#ProductSection-product-template select.single-option-selector", function() {
            adjustProductInventory()
        }), adjustCartDropDown(), adjustProductInventory(),
        function() {
            try {
                if (null != $.cookie(cookieName) && "__" != $.cookie(cookieName) && "" != $.cookie(cookieName))
                    for (var e = String($.cookie(cookieName)).split("__"), t = 0; t < e.length; t++) "" != e[t] && (jQuery(".added-wishbutton-" + e[t]).show(), jQuery(".default-wishbutton-" + e[t]).remove(), jQuery(".loadding-wishbutton-" + e[t]).remove())
            } catch (e) {}
        }(), i()
}), jQuery(window).scroll(function() {
    hb_animated_contents()
});